// i18n-ignore-start: backend API style names mapped to i18n keys for display
const pixiesetStyleNameKeys: Record<string, string> = {
	"Refined Neutral": "styleCard.styleRefinedNeutral",
	"Pastel Warmth": "styleCard.stylePastelWarmth",
	"Cine Wash": "styleCard.styleCineWash",
	"Portrait Glow": "styleCard.stylePortraitGlow",
	"Radiant Gold": "styleCard.styleRadiantGold",
	"Instant Fade": "styleCard.styleInstantFade",
	"Classic Warmth": "styleCard.styleClassicWarmth",
	"Light Diffusion": "styleCard.styleLightDiffusion",
	"Everyday Modern": "styleCard.styleEverydayModern",
	"Matte Gold": "styleCard.styleMatteGold",
	"Rich Tones": "styleCard.styleRichTones",
	"Soft Green": "styleCard.styleSoftGreen",
	GoldTone: "styleCard.styleGoldTone",
	"Legacy Color": "styleCard.styleLegacyColor",
	"TruTone Portrait": "styleCard.styleTruTonePortrait",
	"Natural Ambient": "styleCard.styleNaturalAmbient",
	"Timeless Classic": "styleCard.styleTimelessClassic",
	"Bright & Airy": "styleCard.styleBrightAndAiry",
	"Muted Forest": "styleCard.styleMutedForest",
	"Cine Matte": "styleCard.styleCineMatte",
	Mellow: "styleCard.styleMellow",
	Fern: "styleCard.styleFern",
	Botanic: "styleCard.styleBotanic",
	Cider: "styleCard.styleCider",
	Ethereal: "styleCard.styleEthereal",
	Tuscany: "styleCard.styleTuscany",
	Coral: "styleCard.styleCoral",
	Tea: "styleCard.styleTea",
	Yesteryear: "styleCard.styleYesteryear",
	Terrain: "styleCard.styleTerrain",
	Maillard: "styleCard.styleMaillard",
	Tender: "styleCard.styleTender",
}

const pixiesetStyleDescriptionKeys: Record<string, string> = {
	"Refined Neutral": "styleCard.descRefinedNeutral",
	"Pastel Warmth": "styleCard.descPastelWarmth",
	"Cine Wash": "styleCard.descCineWash",
	"Portrait Glow": "styleCard.descPortraitGlow",
	"Radiant Gold": "styleCard.descRadiantGold",
	"Instant Fade": "styleCard.descInstantFade",
	"Classic Warmth": "styleCard.descClassicWarmth",
	"Light Diffusion": "styleCard.descLightDiffusion",
	"Everyday Modern": "styleCard.descEverydayModern",
	"Matte Gold": "styleCard.descMatteGold",
	"Rich Tones": "styleCard.descRichTones",
	"Soft Green": "styleCard.descSoftGreen",
	GoldTone: "styleCard.descGoldTone",
	"Legacy Color": "styleCard.descLegacyColor",
	"TruTone Portrait": "styleCard.descTruTonePortrait",
	"Natural Ambient": "styleCard.descNaturalAmbient",
	"Timeless Classic": "styleCard.descTimelessClassic",
	"Bright & Airy": "styleCard.descBrightAndAiry",
	"Muted Forest": "styleCard.descMutedForest",
	"Cine Matte": "styleCard.descCineMatte",
	Mellow: "styleCard.descMellow",
	Fern: "styleCard.descFern",
	Botanic: "styleCard.descBotanic",
	Cider: "styleCard.descCider",
	Ethereal: "styleCard.descEthereal",
	Tuscany: "styleCard.descTuscany",
	Coral: "styleCard.descCoral",
	Tea: "styleCard.descTea",
	Yesteryear: "styleCard.descYesteryear",
	Terrain: "styleCard.descTerrain",
	Maillard: "styleCard.descMaillard",
	Tender: "styleCard.descTender",
}
// i18n-ignore-end

export const getLocalizedStyleDisplayName = (name: string, t: (key: string) => string): string => {
	const key = pixiesetStyleNameKeys[name]
	return key ? t(key) : name
}

export const getLocalizedStyleDescription = (
	name: string,
	description: string | undefined,
	t: (key: string) => string,
): string => {
	const key = pixiesetStyleDescriptionKeys[name]
	return key ? t(key) : (description ?? "")
}
